import type {
  AirwallexBeneficiaryDto,
  CreatorPaymentDetailDto,
} from '@/app/pages/admin-options/settings/molecules/creator-payment-details-fix/creator-payment-details.types';

export type BankDetailsViewState =
  | { kind: 'loading' }
  | { kind: 'error'; message: string; canRetry: boolean }
  | { kind: 'none' }
  | { kind: 'available'; beneficiary: AirwallexBeneficiaryDto; paymentDetail: CreatorPaymentDetailDto }
  | { kind: 'unavailable'; paymentDetail: CreatorPaymentDetailDto };

export function isBeneficiaryShaped(value: unknown): value is AirwallexBeneficiaryDto {
  return !!value && typeof value === 'object' && typeof (value as AirwallexBeneficiaryDto).id === 'string';
}

export function deriveBankDetailsViewState(
  detail: CreatorPaymentDetailDto | null | undefined,
): Exclude<BankDetailsViewState, { kind: 'loading' | 'error' }> {
  if (!detail?.airwallexId) {
    return { kind: 'none' };
  }
  if (isBeneficiaryShaped(detail.airwallex)) {
    return { kind: 'available', beneficiary: detail.airwallex, paymentDetail: detail };
  }
  return { kind: 'unavailable', paymentDetail: detail };
}
